import {
  addDays,
  formatLocalDateInput,
  startOfLocalDay,
} from "./subscriptionPeriodDate";

export const REG_IGNORE_ZERO = /\.\d*/gm;
export const REG_IGNORE_ZERO_AND_GAP = /(\.\d*)|([gG]\d*)/gm;

export function isPrintLabelRow(dataStr) {
  if (dataStr === undefined || dataStr === null) {
    return false;
  }
  const s = String(dataStr);
  return /^[wW]\d{2}/.test(s) && !/^[wW]0[hH]0/.test(s);
}

function stripLabelForKey(dataStr) {
  return String(dataStr).replace(REG_IGNORE_ZERO_AND_GAP, "");
}

/**
 * @returns {string|null} canonical labelKey e.g. w15h15
 */
export function normalizeLabelKey(dataStr) {
  if (!isPrintLabelRow(dataStr)) {
    return null;
  }
  const stripped = stripLabelForKey(dataStr);
  const match = stripped.match(/^w(\d+)h(\d+)$/i);
  if (!match) {
    return null;
  }
  return `w${match[1]}h${match[2]}`.toLowerCase();
}

export function formatLabelSizeDisplay(labelKey) {
  const match = String(labelKey).match(/^w(\d+)h(\d+)$/i);
  if (!match) {
    return labelKey;
  }
  return `${match[1]} x ${match[2]}`;
}

export function buildPrintLabelStats(message) {
  const byProductionId = new Map();
  const companyWide = new Map();

  const productions = message?.production;
  if (!Array.isArray(productions)) {
    return { byProductionId, companyWide };
  }

  for (const prod of productions) {
    const productionId = Number(prod?.production_id);
    if (!Number.isFinite(productionId)) {
      continue;
    }
    let prodMap = byProductionId.get(productionId);
    if (!prodMap) {
      prodMap = new Map();
      byProductionId.set(productionId, prodMap);
    }

    const points = prod?.data;
    if (!Array.isArray(points)) {
      continue;
    }

    for (const point of points) {
      if (!isPrintLabelRow(point?.data)) {
        continue;
      }
      const key = normalizeLabelKey(point.data);
      if (!key) {
        continue;
      }
      const count = Number(point.count) || 0;
      prodMap.set(key, (prodMap.get(key) || 0) + count);
      companyWide.set(key, (companyWide.get(key) || 0) + count);
    }
  }

  return { byProductionId, companyWide };
}

/**
 * @param {Map<string, number>|undefined|null} labelMap
 * @returns {{ key: string, count: number, display: string }[]}
 */
export function getProductionLabelList(labelMap) {
  if (!labelMap || labelMap.size === 0) {
    return [];
  }
  const rows = [];
  for (const [key, count] of labelMap.entries()) {
    rows.push({
      key,
      count: Number(count) || 0,
      display: formatLabelSizeDisplay(key),
    });
  }
  rows.sort((a, b) => b.count - a.count);
  return rows;
}

export function getRolling30DayRange() {
  const today = startOfLocalDay();
  const from = addDays(today, -29);
  return {
    from: formatLocalDateInput(from),
    to: formatLocalDateInput(today),
  };
}

/**
 * @param {number} total
 * @param {number} pomot
 * @returns {number|null}
 */
export function calcRolls(total, pomot) {
  const p = Number(pomot);
  if (!Number.isFinite(p) || p <= 0) {
    return null;
  }
  const t = Number(total) || 0;
  return Math.ceil(t / p);
}
